export const getEmptyRow = (columns: any[]) =>
  columns.reduce((acc, column) => ({ ...acc, [column.name]: column.defaultValue ?? null }), {});
